/** Portal V1 screens that may be granted to the representative's producer login. */
export const LEGACY_PORTAL_PERMISSIONS = [
  'Ofertas',
  'Recebimentos',
  'Home',
  'Perfis de Usuários',
  'Mensagens',
  'Contatos',
  'Relatório financeiro',
  'Relatório UTM',
  'Relatórios',
  'Afiliados',
  'Meus Afiliados',
  'Comissões dos Coprodutores',
  'Perfil',
  'Pedidos',
  'Produto',
  'Gestão de Link',
  'Coprodutores',
  'Saque',
  'Conta Corrente',
  'Contas A Receber',
  'Recuperação de compras',
  'Transações',
  'Integrações',
  'Participações dos Coprodutores',
  'Extrato',
  'Usuários',
  'Empresas',
] as const;

/** Product-approved selection used when the onboarding wizard opens. */
export const DEFAULT_LEGACY_PORTAL_PERMISSIONS: string[] = [
  'Ofertas',
  'Recebimentos',
  'Home',
  'Perfis de Usuários',
  'Mensagens',
  'Contatos',
  'Relatório financeiro',
  'Relatórios',
  'Perfil',
  'Pedidos',
  'Produto',
  'Saque',
  'Conta Corrente',
  'Contas A Receber',
  'Transações',
  'Extrato',
  'Usuários',
  'Empresas',
];
